import { render, staticRenderFns } from "./search-input.vue?vue&type=template&id=72b038f8"
import script from "./search-input.vue?vue&type=script&lang=js"
export * from "./search-input.vue?vue&type=script&lang=js"
import style0 from "./search-input.vue?vue&type=style&index=0&id=72b038f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports